const authorizationCode = state => state.common.authorizationCode ?? ''

export { authorizationCode }
